var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitterMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.69 0 0 2.69 0 6v12c0 3.31 2.69 6 6 6h12c3.31 0 6-2.69 6-6V6c0-3.31-2.69-6-6-6Zm-.04 8.94v.4c0 4.07-3.1 8.76-8.76 8.76-1.74 0-3.36-.51-4.72-1.38.24.03.49.04.73.04 1.44 0 2.77-.49 3.82-1.32a3.07 3.07 0 0 1-2.87-2.14c.19.04.38.06.58.06.28 0 .55-.04.81-.11a3.08 3.08 0 0 1-2.47-3.02v-.04c.42.23.89.37 1.39.39A3.058 3.058 0 0 1 5.1 8.02c0-.56.15-1.09.42-1.55a8.765 8.765 0 0 0 6.34 3.22 3.081 3.081 0 0 1 3-3.78c.89 0 1.68.37 2.25.97.7-.14 1.36-.39 1.95-.75-.23.72-.72 1.32-1.35 1.7a6.18 6.18 0 0 0 1.77-.48c-.41.62-.93 1.16-1.54 1.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitterMono);
export default __webpack_public_path__ + "static/media/social-twitter-mono.917be0701bc7d2ba6f67bd9490885055.svg";
export { ForwardRef as ReactComponent };